module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_pet@3x-51a7a7d05355b49ae0f1a00681b3a584.webp";